<script lang="ts">
  import Modal from './Modal.svelte';
  import Button from './Button.svelte';
  import { dialogs } from '../toast.svelte';
  import { t } from '../i18n.svelte';

  let typed = $state('');
  const current = $derived(dialogs.current);
  const ready = $derived(!current?.typeToConfirm || typed.trim() === current.typeToConfirm);
  $effect(() => {
    if (current) typed = '';
  });
</script>

{#if current}
  <Modal open={true} title={current.title} size="sm" onclose={() => dialogs.close(false)}>
    {#if current.message}<p class="msg">{current.message}</p>{/if}
    {#if current.typeToConfirm}
      <label class="type">
        <span>{t('common.type_to_confirm', { text: current.typeToConfirm })}</span>
        <input class="control" bind:value={typed} autocomplete="off" data-autofocus />
      </label>
    {/if}
    {#snippet footer()}
      <Button variant="ghost" onclick={() => dialogs.close(false)}>{current.cancelLabel || t('common.cancel')}</Button>
      <Button variant={current.danger ? 'danger' : 'primary'} disabled={!ready} onclick={() => dialogs.close(true)} data-autofocus={current.typeToConfirm ? undefined : true}>
        {current.confirmLabel || t('common.confirm')}
      </Button>
    {/snippet}
  </Modal>
{/if}

<style>
  .msg { color: var(--text-2); font-size: var(--text-md); white-space: pre-line; }
  .type { display: flex; flex-direction: column; gap: var(--space-2); margin-top: var(--space-4); font-size: var(--text-sm); color: var(--text-2); }
</style>
